import { render } from "./SliderCard.vue?vue&type=template&id=f8c3ab9a&scoped=true"
import script from "./SliderCard.vue?vue&type=script&lang=js"
export * from "./SliderCard.vue?vue&type=script&lang=js"

import "./SliderCard.vue?vue&type=style&index=0&id=f8c3ab9a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8c3ab9a"]])

export default __exports__